<template>
    <dashboard-layout>
        <v-container fluid class="down-top-padding py-0">
            <BaseBreadcrumb
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
            ></BaseBreadcrumb>
            <v-row dense>
                <v-col cols="12">
                    <table-system-order-region></table-system-order-region>
                </v-col>
            </v-row>
        </v-container>
    </dashboard-layout>
</template>

<script>
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import TableSystemOrderRegion from './TableGrids/TableSystemOrderRegion.vue'

export default {
    name: 'SystemOrderRegions',
    props: {

    },
    components: {
        DashboardLayout,
        BaseBreadcrumb,
        TableSystemOrderRegion,
    },
    data() {
        return {
            page: {
                title: "Order Regions",
            },
            breadcrumbs: [
                { text: "Order Regions", disabled: true },
            ],
        }
    },
    watch: {},
    computed: {},
    mounted: function () {},
    methods: {

    }
}
</script>
